module.exports = __webpack_public_path__ + "static/img/1047.64326f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1047.jpg
// module id = 229
// module chunks = 0